import script from "./TableHeaderInvoiceHospital.vue?vue&type=script&setup=true&lang=js"
export * from "./TableHeaderInvoiceHospital.vue?vue&type=script&setup=true&lang=js"

import "./TableHeaderInvoiceHospital.vue?vue&type=style&index=0&id=489920df&lang=css"

const __exports__ = script;

export default __exports__